import { PopupChat, PopupChatFunctions } from '../../commons/components/PopupChat';
import { CHAT_TYPE_BUSINESS_PLAN } from '../../growegy-ai/dto';
import { AiStarsSolid } from '../../assets/icons';
import { Chat } from '../../growegy-ai/types';
import { ForwardedRef, forwardRef } from 'react';
import { useIsSmallerThanTablet } from '../../responsive/hooks/hooks';

export const SurveySectionChat = forwardRef(
  (
    props: {
      selectedChat: Chat | null;
      systemMessage: string | (() => string) | null;
      onToolCallProceed?: () => void;
    },
    ref: ForwardedRef<PopupChatFunctions>
  ) => {
    const { selectedChat, systemMessage, onToolCallProceed } = props;
    const isSmallerThanTablet = useIsSmallerThanTablet();

    return (
      <PopupChat
        ref={ref}
        systemMessage={systemMessage}
        chatType={CHAT_TYPE_BUSINESS_PLAN}
        dataTestPrefix={'survey-section'}
        top={8}
        bottom={56}
        right={isSmallerThanTablet ? 8 : 48}
        left={8}
        width="unset"
        icon={() => <AiStarsSolid className="growegy-ai__floating-button-icon" />}
        selectedChat={selectedChat}
        onToolCallProceed={onToolCallProceed}
      />
    );
  }
);
